import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { NegotiationDetail, AuthorisedUser, NegotiationActions, NegotiationEvent, NegotiationStatus } from 'api'
import { Tooltip } from 'view/components/tooltip'
import { LockWrapper, LockButton, LockIcon, LockedUser } from 'view/shared/datagrid'
import { getUserInitials, getUserFullName } from 'model'
import { createAuthorisedUserSelector } from 'selectors/connectionSelectors'
import { Locale, Translation } from 'locale'
import { rfqIconSet } from '../shared/rfqIconSet'

export interface LiveLockRendererProps {
  className?: string
  authorisedUser: AuthorisedUser
  negotiationDetail: NegotiationDetail
  fullLabel?: boolean
  onLock: (negotiationId: string, ownOrder: boolean) => unknown
  onUnlock: (negotiationId: string, ownOrder: boolean) => unknown
}

const mapStateToProps = createStructuredSelector({
  authorisedUser: createAuthorisedUserSelector()
})

const mapDispatchToProps = {
  onLock: NegotiationActions.lock,
  onUnlock: NegotiationActions.unlock
}

export class LiveLockRendererComponent extends React.Component<LiveLockRendererProps> {
  render() {
    const { className, negotiationDetail, authorisedUser, fullLabel } = this.props
    const userWithLock = negotiationDetail.userWithLock
    const isUserWithLock = userWithLock ? userWithLock.id === authorisedUser.id : true

    return (
      <LockWrapper className={className} data-test-id="LiveLockRenderer-Wrapper">
        <Tooltip tooltip={userWithLock ? Locale.translate(Translation.SC_LOCKED_TO, { user: getUserFullName(userWithLock) }) : ''}>
          {/* Need to wrap children in div in order to show tooltip when children is disabled */}
          <div>
            <LockButton
              isLocked={!!userWithLock}
              onClick={this.handleLock}
              disabled={!isUserWithLock || negotiationDetail.negotiation.status === NegotiationStatus.QUOTED}
              dataTestId="LiveLockRenderer-LockButton">
              <LockIcon data-test-id="LiveLockRenderer-LockIcon">{rfqIconSet.lock}</LockIcon>
              <LockedUser>
                {userWithLock
                  ? fullLabel
                    ? Locale.translate(Translation.SC_LOCKED_TO, { user: getUserInitials(userWithLock) })
                    : getUserInitials(userWithLock)
                  : fullLabel
                  ? Locale.translate(Translation.SC_UNLOCKED)
                  : null}
              </LockedUser>
            </LockButton>
          </div>
        </Tooltip>
      </LockWrapper>
    )
  }

  private handleLock = () => {
    const { negotiationDetail, authorisedUser, onLock, onUnlock } = this.props
    const { negotiation, availableEvents, userWithLock } = negotiationDetail
    if (availableEvents.includes(NegotiationEvent.LOCK) && userWithLock === null) {
      onLock(negotiation.negotiationId, negotiationDetail.ownOrder)
    } else if (availableEvents.includes(NegotiationEvent.UNLOCK) && userWithLock && userWithLock.username === authorisedUser.username) {
      onUnlock(negotiation.negotiationId, negotiationDetail.ownOrder)
    }
  }
}

export const LiveLockRenderer = connect(mapStateToProps, mapDispatchToProps)(LiveLockRendererComponent)
